// TODO: remove these once the mock data is out
/* eslint-disable max-len, quote-props, quotes, comma-dangle, indent, no-trailing-spaces */
// @flow

import Service from './service';
import type { ApiConstructorArgsType } from '../types/api';
import type {
  ProfessionsResponseType,
  ExpenseCategoriesResponseType,
  ExpenseCategoryType,
} from '../types/tax-deduction';

const jwtRequired = 'JWT required for personalized request';
const professionIdsRequired = 'Must supply an array of professionIds';

export default class TaxDeductionService extends Service {
  constructor(args: ApiConstructorArgsType = {}) {
    super(args);
    this.baseUrl = this.conf.path.gpsBase;
  }

  getProfessions(options: Object = {}): Promise<ProfessionsResponseType> {
    return this.api.get(`${this.baseUrl}/content/public/professions`, options)
      .then(r => r.data);
  }

  getPersonalizedProfessions(jwt: string, options: Object = {}): Promise<ProfessionsResponseType> {
    if (!jwt) {
      return Promise.reject(jwtRequired);
    }

    return this.api.get(
      `${this.baseUrl}/content/professions`,
      { headers: { 'jwt-internal-authorization': jwt }, ...options },
    )
      .then(r => r.data);
  }

  getExpenseCategories(professionIds: Array<number>, options: Object = {}):
  Promise<ExpenseCategoriesResponseType> {
    if (!Array.isArray(professionIds)) {
      return Promise.reject(professionIdsRequired);
    }

    const url = `${this.baseUrl}/content/public/categories?professions=${professionIds.join(',')}`;
    return this.api.get(url, options)
      .then(r => r.data);
  }

  getPersonalizedExpenseCategories(jwt: string, options: Object = {}):
  Promise<ExpenseCategoriesResponseType> {
    if (!jwt) {
      return Promise.reject(jwtRequired);
    }

    return this.api.get(
      `${this.baseUrl}/content/categories`,
      { headers: { 'jwt-internal-authorization': jwt }, ...options },
    )
      .then(r => r.data);
  }

  getStaticCategories(idParams?: Array<number>, options: Object = {}):
  Promise<{ categories: { [key: string]: Array<ExpenseCategoryType> } }> {
    const query = idParams ? `?externalIds=${idParams.join(',')}` : '';
    const url = `${this.baseUrl}/content/public/categoryLists${query}`;
    return this.api.get(url, options)
      .then(r => r.data);
  }

  postProfessions(professionIds: Array<number>, jwt: string, options: Object = {}):
  Promise<{ professions: Array<number> }> {
    if (!Array.isArray(professionIds) || !professionIds.length) {
      return Promise.reject(professionIdsRequired);
    }
    if (!jwt) {
      return Promise.reject(jwtRequired);
    }

    return this.api.post(
      `${this.baseUrl}/professions`,
      { professions: professionIds },
      { headers: { 'jwt-internal-authorization': jwt }, ...options }
    ).then(r => r.data);
  }
}
